import React, { } from "react";
import { Box, Typography } from "@mui/material";
import { BroadcastMessages } from "./BroadcastMessages";

const BroadcastMessagesPage = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Typography variant="h5" fontWeight={700} color="primary.main" mb={1.5}>Broadcast</Typography>
      <BroadcastMessages />
    </Box>
  );
};

export default BroadcastMessagesPage;